import React from 'react';
import { Check, ArrowRight } from 'lucide-react';


const Bestsellers = () => {
  const plans = [
    {
      title: 'Hourly Plan',
      badge: null,
      tagline: 'Quickest Content',
      taglineColor: 'tagline-red',
      description: 'Perfect for anyone who want a single, fast, high-quality reel.',
      price: '1,999',
      features: [
        '1 Hour Shoot',
        '1 Edited Reel Delivered',
        'Shot on Latest iPhone',
        'Fast Delivery (10 mins post shoot)',
        'Trained and Certified Reel Maker',
        'Flashoot Branding Included'
      ]
    },
    {
      title: 'Half-Day Plan',
      badge: 'MOST POPULAR',
      tagline: 'Event Essential',
      taglineColor: 'tagline-yellow',
      description: 'Ideal for events and creators who need more time and more content.',
      price: '4,999',
      features: [
        'Up to 3 Hours Shoot',
        '2 Edited reels',
        'Shot on Latest iPhone',
        'Fast Delivery (10 mins post shoot)',
        'Trained and Certified Reel Maker',
        'Flashoot Branding Included'
      ]
    }
  ];

  return (
    <div className="bestsellers-section">
      <div className="bestsellers-container">
        <h1 className="bestsellers-title">Bestsellers</h1>

        <div className="plans-grid">
          {plans.map((plan, index) => (
            <div key={index} className="plan-card">
              {/* Badge */}
              {plan.badge && (
                <div className="badge-container">
                  <span className="badge">{plan.badge}</span>
                </div>
              )}

              {/* Header */}
              <div className="plan-header">
                <h2 className="plan-title">{plan.title}</h2>
                <p className={`plan-tagline ${plan.taglineColor}`}>
                  {plan.tagline}
                </p>
                <p className="plan-description">{plan.description}</p>
              </div>

              {/* Price */}
              <div className="plan-price">
                <div className="price-amount">₹{plan.price}</div>
                <p className="price-gst">+ GST</p>
              </div>

              {/* Features */}
              <div className="plan-features">
                <p className="features-title">WHAT'S INCLUDED</p>
                <div className="features-list">
                  {plan.features.map((feature, idx) => (
                    <div key={idx} className="feature-item">
                      <Check className="check-icon" />
                      <span className="feature-text">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Button */}
              <button className="book-button">
                <span className="rupee-symbol">₹</span>
                <span>Book Now</span>
                <ArrowRight className="arrow-icon" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bestsellers;